import { AnimatePresence } from "framer-motion";
import { BrowserRouter as Router, Routes, Route, useLocation , Navigate } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Analytics } from '@vercel/analytics/react';
import theme from "./theme";
import GlobalStyle from "./GlobalStyle";
import ScrollToTop from "./ScrolltoTop";

import Home from "./pages/home";
import About from "./pages/about";
import Work from "./pages/Work";



function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route index element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Work />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <ScrollToTop />
        <AnimatedRoutes />
      </Router>
      <Analytics />
    </ThemeProvider>
  );
}

export default App;
